export type Action =
  | 10 // BUY_SEEDS
  | 11 // BUY_PLANTS
  | 20 // SOW_WITH_THE_HEAT
  | 21 // SOW_IN_GREENHOUSE
  | 22 // SOW_IN_GARDEN
  | 30 // PLANT
  | 40 // EARLY_HARVEST
  | 41 // HARVEST
  | 50 // FLOWERING
  | 60 // MOW
  | 70 // DIVIDE
  | 110; // WATER (garden-level, auto-generated from the weather)

export const ACTION_LABELS: Record<number, string> = {
  10: "Acheter des graines",
  11: "Acheter des plants",
  20: "Semer au chaud",
  21: "Semer sous abri",
  22: "Semer en pleine terre",
  30: "Planter",
  40: "Première récolte",
  41: "Récolter",
  50: "Floraison",
  60: "Faucher",
  70: "Diviser",
  110: "Arroser",
};

// Some actions are plant states rather than things the user does (e.g. Floraison),
// or are generated by the backend (Arroser). They keep a label for displaying
// existing tasks but aren't offered when creating one.
const NON_SELECTABLE_ACTIONS: Action[] = [50, 110];

// Actions the user can pick when creating a task, as { value, title } options.
export const SELECTABLE_ACTION_OPTIONS = Object.entries(ACTION_LABELS)
  .map(([value, title]) => ({ value: Number(value) as Action, title }))
  .filter((option) => !NON_SELECTABLE_ACTIONS.includes(option.value));
